<template>
 <div class="d-flex">
      <v-tooltip bottom class="d-flex">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{cmpValor.length > 20 ? cmpValor.slice(0,19)+'...' : cmpValor}}</span>
        </template>
        <span>{{cmpValor}}</span>
      </v-tooltip>
      <v-spacer></v-spacer>

      <v-btn color="primary" class="mx-0" outlined x-small icon :disabled="!cmpPermisos" @click="isEditNFC = true">
        <v-icon right size="13px" class="btncolor--text mx-1">
          mdi-pencil
        </v-icon>
      </v-btn>

  <v-dialog
    v-model="isEditNFC"
    hide-overlay
    max-width="400px"
    transition="dialog-bottom-transition">
   <v-card>
    <v-toolbar
      height="30px"
      dark
      color="primary">
      <v-toolbar-title> NFC</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="isEditNFC = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <!-- editar NFC -->
      <FormTexto
        class="mt-2"
        v-model="sNFCValor"
        titulo="Número de NFC"
        :editable="'1'"
        :obligatorio="true">
      </FormTexto>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="no-uppercase btn-rounded d-flex ma-0 mx-2" color="primary" dark @click="onClose">
          Cancelar
      </v-btn>
      <v-btn class="no-uppercase btn-rounded d-flex ma-0 mx-2" color="primary" dark @click="onGuardar">
          Guardar
      </v-btn>
    </v-card-actions>
    </v-card>
    <ModalMensajeGeneral v-model="oModalMensaje.bModalVisible" :sMensaje="oModalMensaje.sMensaje" :nTipo="oModalMensaje.nTipo"/>
  </v-dialog>

  </div>
</template>

<script>
import mixinGridComponenteCelda from "@/mixins/GridComponenteCelda.js"
import axiosServices from '@/services/axiosServices.js'
import FormTexto from '@/components/Form/Componentes/FormTexto.vue'

export default {
  name: 'CeldaNFC',
  mixins: [mixinGridComponenteCelda],
  components: {
    FormTexto,
  },
  data() {
    return {
      isEditNFC: false,
      sNFCValor : '',
      oModalMensaje: {
        bModalVisible: false,
        sMensaje: '',
        nTipo: 4
      },

    };
  },
  mounted () {
    this.sNFCValor = this.valor 
  },
  methods: {
    async onGuardar() {
      const aDataWhere = {}
      const sValor = (this.sNFCValor != null && this.sNFCValor != '') ? this.sNFCValor.trim() : ''
      this.sIdTable.split(',').forEach(sItem =>{
        aDataWhere[sItem] = (this.oDataParent[sItem])
      })
      const oBody = {
        sTable  : this.sTabla,
        sCampo  : this.sCampo,
        sValor  : sValor,
        aCampos : aDataWhere
      }
      const axiosChange = await axiosServices.putConfiguration('/pGrids_changeCampo', oBody , true , `sTable=${this.sTabla}` )
      if(axiosChange.sStatus === 'success' ) {
        this.oModalMensaje.sMensaje = 'NFC almacenado con exito'
        this.oModalMensaje.nTipo = 4
        this.bGenerarOK = true
        this.valor = sValor  // Esto me mantiene el cambio en la grid
      } else {
        this.oModalMensaje.sMensaje = 'Problemas almacenando el NFC, llame a su administrador'
        this.oModalMensaje.nTipo = 3
      }  
      this.oModalMensaje.bModalVisible = true
    },
    onClose(){
      this.sNFCValor = this.valor
      this.isEditNFC = false
    }
  },
  computed: {
    cmpValor() {
      return (this.sNFCValor != null &&  this.sNFCValor != '') ? this.sNFCValor : 'No Aplica'
    }
  },
  watch: {
    isEditNFC() {
      if(this.isEditNFC) this.sNFCValor = this.valor
    },
  },
};
</script>
<style lang="scss" scoped>
</style>